import { slideHorizontalTo } from '@intelligence/pages/TopCharts/PCGames/components/SliderSegement/slide';

function useMetricTableAutoScroll(props: any) {
  const { data, getSlideNode } = props || {};

  const calculateSlideDistance = (value?: string): number => {
    let distance = 0;
    try {
      const index = data.findIndex((item: any) => item.value === value);
      if (index !== -1) {
        for (let j = 0; j < index; j++) {
          if (data[j]?.fixed) continue;
          const width = data[j]?.width;
          if (Number.isNaN(width)) {
            throw new Error('宽表存在没有配置宽度的列 宽表锚点定位');
          }
          distance += width;
        }
      }
    } catch (e) {
      console.error(e);
      distance = 0;
    }
    return distance;
  };

  const doAnchor = (value?: string) => {
    if (!(getSlideNode instanceof Function || !value)) return;
    const slideNode = getSlideNode();
    if (Array.isArray(slideNode)) {
      slideNode.forEach((node) => {
        if (!node) return;
        slideHorizontalTo(node, calculateSlideDistance(value));
      });
    } else {
      if (!slideNode) return;
      slideHorizontalTo(slideNode, calculateSlideDistance(value));
    }
  };

  return {
    autoScroll: doAnchor,
  };
}

export default useMetricTableAutoScroll;
